import './App.css';
import VideoPlayer from './components/VideoPlayer';
import Footer from './components/Footer';
import TontonNavbar from './components/TontonNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import BHlogo from './Images/logo-bh.png';
import NSTLogo from './Images/logo-nst.png';
import MetroLogo from './Images/logo-metro.png';
import BUTVLogo from './Images/logo-butv.png';
import OhBulanLogo from './Images/ohbulan.png';
import SaysLogo from './Images/logo-says.png';
import EightTVLogo from './Images/logo-8tv.png';
import { useEffect, useState } from 'react';
import Analytics from './Analytics';


function App() {
  const [visiblePlayers,setVisiblePlayers] = useState({
    BHTV : true,
    NSTTV : true,
    HMTV : true,
    BUTV: true,
    OB: true,
    SAYS: true,
    '8TV': true
  });

  const toggleVideoPlayer = (key) => {
    setVisiblePlayers({
      BHTV : key === 'BHTV',
      NSTTV : key === 'NSTTV',
      HMTV : key === 'HMTV',
      BUTV : key === 'BUTV3',
      OB: key === 'OHBULAN!',
      SAYS: key === 'SAYS',
      '8TV': key === '8TV'
    });

    if(key === 'All'){
      setVisiblePlayers({
        BHTV : true,
        NSTTV : true,
        HMTV : true,
        BUTV: true,
        OB: true,
        SAYS: true,
        '8TV': true
      });
    }
  }

  const adTags = {
    BHTV: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_BH&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    NSTTV: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_NST&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    HMTV: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_HM&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    BUTV: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_BUTV3&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    OB: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_OB&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    SAYS: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_SAYS&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
    '8TV': 'https://pubads.g.doubleclick.net/gampad/ads?iu=/1009103/Tonton_Klip_8TV&description_url=http%3A%2F%2Fwww.tonton.com.my&tfcd=0&npa=0&sz=360x640&gdfp_req=1&vid_d=3000&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator=',
  };

  const gtmConfigs = {
    BHTV:  { listId: 'BHTV',  listName: 'BH vertical video',  category: 'BH Online',  category2: 'video terkini' },
    NSTTV: { listId: 'NSTTV', listName: 'NST vertical video', category: 'NST TV',     category2: 'Latest Video'  },
    HMTV:  { listId: 'HMTV',  listName: 'HM vertical video',  category: 'HM Online',  category2: 'video terkini' },
    BUTV:  { listId: 'BUTV3', listName: 'BUTV vertical video', category: 'BUTV3',     category2: 'video terkini' },
    OB:    { listId: 'OB',    listName: 'OhBulan vertical video', category: 'OhBulan', category2: 'video terkini' },
    SAYS:  { listId: 'SAYS',    listName: 'SAYS vertical video', category: 'SAYS', category2: 'video terkini' },
    '8TV':  { listId: '8TV',    listName: '8TV vertical video', category: '8TV', category2: 'video terkini' },
  };

  useEffect(() => {
    // Initialize GA with your measurement ID
    Analytics.initGA('G-TN8ZFXMB96');
    
    // Log initial page view
    Analytics.logPageView();
    
    // Set up page view tracking on route changes
    if (window.location) {
      const handleRouteChange = () => {
        Analytics.logPageView();
      };
      
      // If you're using react-router, you can use its history to track page changes
      // history.listen(handleRouteChange);
    }
  }, []);

  return (
    <div className="App">
      <TontonNavbar toggleVideoPlayer={toggleVideoPlayer}/>

      {visiblePlayers.BHTV && (
        <VideoPlayer title="Video Terkini" titleLink="Video Terkini" titleLinkText="Video Terkini" Api_url="https://cdn.jwplayer.com/v2/playlists/ZSNDHNiC?format=json" adTag={adTags.BHTV} logo={BHlogo} gtmConfig={gtmConfigs.BHTV}/>
      )}

      {visiblePlayers.NSTTV && (
        <VideoPlayer title="Latest Videos" titleLink="Latest Videos" titleLinkText="Latest Video" Api_url="https://cdn.jwplayer.com/v2/playlists/5GcfhG1Z?format=json" adTag={adTags.NSTTV} logo={NSTLogo} gtmConfig={gtmConfigs.NSTTV}/>
      )}
      
      {visiblePlayers.HMTV && (
        <VideoPlayer title="Video Terkini" titleLink="Video Terkini" titleLinkText="Video Terkini" Api_url="https://cdn.jwplayer.com/v2/playlists/pWE6Ijlz?format=json" adTag={adTags.HMTV} logo={MetroLogo} gtmConfig={gtmConfigs.HMTV}/>
      )} 

      {visiblePlayers.BUTV && (
        <VideoPlayer title="Video Terkini" titleLink="Video Terkini" titleLinkText="Video Terkini" Api_url="https://cdn.jwplayer.com/v2/playlists/qedDAy1O?format=json" adTag={adTags.BUTV} logo={BUTVLogo} logoName='logo-butv' gtmConfig={gtmConfigs.BUTV}/>
      )}

      {visiblePlayers['8TV'] && (
        <VideoPlayer title="Video Terkini" titleLink="Video Terkini" titleLinkText="Video Terkini" Api_url="https://cdn.jwplayer.com/v2/playlists/gb9zsVZ2?format=json" adTag={adTags['8TV']} logo={EightTVLogo} gtmConfig={gtmConfigs['8TV']}/>
      )}

      {visiblePlayers.OB && (
        <VideoPlayer title="Video Terkini" titleLink="Video Terkini" titleLinkText="Video Terkini" Api_url="https://cdn.jwplayer.com/v2/playlists/LdikCjhw?format=json" adTag={adTags.OB} logo={OhBulanLogo} logoName='logo-ob' gtmConfig={gtmConfigs.OB}/>
      )}

      {visiblePlayers.SAYS && (
        <VideoPlayer title="Latest Videos" titleLink="Latest Videos" titleLinkText="Latest Video" Api_url="https://cdn.jwplayer.com/v2/playlists/6qhpxz66?format=json" adTag={adTags.SAYS} logo={SaysLogo} logoName='logo-ob' gtmConfig={gtmConfigs.SAYS}/>
      )}



      <Footer/>
    </div>
  );
}

export default App;